export default [
  {
    path: '/golddata',
    name:'golddata',
    meta: {
      keepAlive: true,
      pathName: 'golddata'
    },
    component: resolve => require(['../view/goldData/index'], resolve),
  },
  {
    path: '/goldcustomer/:id',
    meta: {
      keepAlive: true,
      pathName: 'goldcustomer'
    },
    component: resolve => require(['../view/goldData/customer'], resolve),
  }
]



// WEBPACK FOOTER //
// ./src/router/goldData.js